module.exports = __webpack_public_path__ + "img/footerlogo.4b76030b.svg";